import { filter, map } from 'lodash';
/**
   * @ngdoc service
   * @name adjust.service:ProductUpdate
   * @description
   * Model for managing product updates
   */
function ProductUpdate(Api) {
  'ngInject';
  return {
    seen: seen,
    getUpdates: getUpdates,
    getUnauthenticated: getUnauthenticated
  };

  /**
   * Safely fetches the list of product updates and filters them by account id
   * without propagating errors. In case of failure an empty array is resolved.
   *
   * @param {Number} accountId current account id
   * @param {String} locale current user language
   * @returns {Promise} A promise representing the state of the product updates request
   */
  function getUpdates(accountId, locale) {

    return Api.productUpdate.query({
      locale: locale
    })
      .$promise
      .then(function(resp) {
        return _filterUpdatesForAccount(resp || [], accountId);
      })
      .catch(function() {
        return [];
      });

  }

  /**
   * Filters a list of product updates by account for all updates that have an
   * account constrain defined
   *
   * @param {Array} updates
   * @param {Number} accountId
   * @returns {Promise}
   */
  function _filterUpdatesForAccount(updates, accountId) {

    return filter(updates, function(update) {

      return update.account_ids ?
        update.account_ids.includes(accountId) :
        true;

    });

  }

  /**
   * @ngdoc method
   * @name getUnauthenticated
   * @methodOf adjust.service:ProductUpdate
   * @description
   * Get product updates for unauthenticated user
   *
   * @param {String} locale browser language
   *
   * @returns {promise} A promise representing the state of the product updates request
   */
  function getUnauthenticated(locale) {

    return Api.unauthenticatedProductUpdate.query({
      locale: locale
    }).$promise;

  }

  /**
   * @ngdoc method
   * @name seen
   * @methodOf adjust.service:ProductUpdate
   * @description
   * Registers seen on the given product updates
   *
   * @param {Array} productUpdates array of product updates
   *
   * @returns {promise} A promise representing the state of the product updates request
   */
  function seen(productUpdates) {

    return Api.productUpdate.save({
      action: 'seen',
      permalink: map(productUpdates, 'permalink').join()
    }).$promise;

  }
}


export { ProductUpdate };
